import { AcornsIcon } from '@acorns/icons'
import { Footnote } from '@acorns/web-components'
import styled from 'styled-components'

import Button from 'components/Button'
import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const Background = styled.div`
  background-color: ${style(theme => theme.colors.slate)};
  min-height: 100vh;
  height: 100%;
  background-repeat: no-repeat;
  overflow-y: auto;
  display: flex;
  flex-flow: column;
`

export const StyledLayout = styled.div`
  padding: 10px 0px 14px 0px;
  position: relative;
  height: 100%;
  min-height: 430px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 30px 60px;
  flex-grow: 1;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    overflow-y: auto;
    justify-content: flex-start;
  }
`

export const ActionWrapper = styled.div`
  margin-top: 80px;

  @media (max-width: ${style(theme => theme.breakpoints.md)}) {
    margin-top: 90px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background: linear-gradient(
      360deg,
      rgba(25, 25, 25, 1) 0%,
      rgba(25, 25, 25, 1) 79%,
      rgba(255, 255, 255, 0) 96%
    );
    bottom: 0;
    left: 0;
    padding: 15px 0 20px 0;
    position: fixed;
    width: 100%;
    z-index: 1;
  }
`

export const Eyebrow = styled.span`
  color: ${style(theme => theme.colors.white)};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
`

export const EyebrowText = styled.span`
  bottom: 4px;
  position: relative;
`

export const Green = styled.span`
  color: ${style(theme => theme.colors.green)};
  display: inline-block;
`

export const Link = styled.span`
  cursor: pointer;
  text-decoration: underline;
`

export const StyledBody = styled(Body)`
  color: ${style(theme => theme.colors.white)};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 10px;
  max-width: 400px;
  text-align: left;
`
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 400px;
  margin: 0 auto;
  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    max-width: 340px;
  }
`

export const StyledButton = styled(Button)`
  color: ${style(theme => theme.colors.slate)};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px 10px;
  width: 220px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    bottom: 15px;
    height: 44px;
    margin: 8px auto 0px;
    position: relative;
    width: 335px;
    max-width: 100%;
  }
`

export const StyledImage = styled.img`
  max-width: 315px;
  display: flex;
  justify-content: center;
  position: relative;
  margin: 20px auto 0px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }

  @media (max-width: 375px) {
    margin-bottom: 44px;
  }
`

export const StyledFootnote = styled(Footnote)`
  color: ${style(theme => theme.colors.white)};
  z-index: 2;
`

export const StyledTitle = styled(Heading2)`
  color: ${style(theme => theme.colors.white)};
  font-size: 40px;
  font-weight: 600;
  line-height: 55px;
  margin: 30px auto 6px;
  text-align: left;
`

export const StyledTextButton = styled(Button)`
  color: ${style(theme => theme.colors.white)};
  height: 22px;
  position: relative;
  line-height: 22px;
  margin-top: 20px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    bottom: 20px;
  }
`

export const ModalContainer = styled.div`
  & :last-child {
    margin-bottom: 0;
  }
`

export const ModalText = styled.p`
  line-height: 22px;
  margin-top: 0;
  margin-bottom: 20px;
`
export const WhiteIcon = styled(AcornsIcon)`
  margin-right: 10px;
  path {
    &[fill] {
      fill: ${style(theme => theme.colors.white)};
    }
  }
`

export const NavBar = styled.div<{ isDesktop: boolean }>`
  width: 100%;
  padding: 30px 35px;

  display: flex;
  justify-content: space-between;

  color: ${style(theme => theme.colors.white)};
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding: 24px;
  }
`
